import { useI18n } from '../../../shared/i18n/useI18n.js'

import { Button } from '../../../shared/ui/Button/index.js'

import styles from './FavoritesPlaceholder.module.scss'

/**
 * Empty state for the favorites section.
 * Guides the user back to the catalog when no products are saved.
 */
export function FavoritesPlaceholder({ onDiscoverProducts }) {

  // ── i18n ──────────────────────────────────────────────────────────────────
  const { t } = useI18n()

  // ── Render ────────────────────────────────────────────────────────────────
  return (
    <div className={styles.root}>
      <h3 className={styles.title}>{t('favorites.empty_title')}</h3>
      <p className={styles.description}>{t('favorites.empty_description')}</p>
      <div className={styles.actions}>
        <Button
          kind="text"
          size="medium"
          cta
          onClick={onDiscoverProducts}
        >
          {t('favorites.discover_products')}
        </Button>
      </div>
    </div>
  )
}
